const getApiUrl = () => process.env.REACT_APP_URL_PROD_MEDAM;
// process.env.REACT_APP_PROD_MEDAM || process.env.REACT_APP_URL_PROD_MEDAM;

export const createPreOrder = async (payload) => {
  const baseUrl = (getApiUrl() || "").replace(/\/+$/, "");

  if (!baseUrl) {
    throw new Error("No se encontró la URL de la API");
  }

  try {
    const response = await fetch(`${baseUrl}/preOrder/createPreOrder`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    const contentType = response.headers.get("content-type") || "";
    const data = contentType.includes("application/json")
      ? await response.json()
      : { message: await response.text() };

    if (!response.ok) {
      throw new Error(data?.message || `HTTP ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error("Error al crear la pre-orden:", error);
    throw error;
  }
};
